import { render, staticRenderFns } from "./ExamenesLista.vue?vue&type=template&id=dd844a1a&"
import script from "./ExamenesLista.vue?vue&type=script&lang=js&"
export * from "./ExamenesLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports